import React, { useEffect, useState } from "react";
import { Box, Tab, Dialog, Slide } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Moment from "moment";

import "./mobileLeaderboard.css";
import { leaderboardDetails } from "../../services/questionApi";
import { useDispatch, useSelector } from "react-redux";
import {
  LeaderBoardList,
  SetDateAndDay,
  SetDay,
  SetLeaderBoardTabs,
  SetWeekDay,
} from "../../actions";
import Leaderboard from "../../components/leaderboard/Leaderboard";
import useWinners from "../../hooks/useWinners";
import { useSettings } from "../../hooks/useSettings";
import GoldenBallPromo from "../profile/components/goldenBallPromo/GoldenBallPromo";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MobileLeaderboard = () => {
  const dispatch = useDispatch();
  const leaderboardData = useSelector((state) => state.leaderboard.items);
  const weekDays = useSelector((state) => state.weekDays);
  const { tab, week, day } = useSelector(
    (state) => state.leaderboardTab,
  );

  const [openDaily, setOpenDaily] = useState(false);
  const [openWeek, setOpenWeek] = useState(false);

  const { finalWinners } = useWinners();
  console.log("finalWinners",finalWinners)
  const settings = useSettings();

  const matchDayEnabled = true

   const matchDays = React.useMemo(
    () =>
      settings?.match_dates
        ? [...settings.match_dates]
            .filter((item) => Moment(item.start_date, "YYYY-MM-DD").isSameOrBefore(Moment(), "day"))
            .reverse()
        : [],
    [settings?.match_dates],
  );

  // 🔹 Fetch leaderboard automatically on tab/week/date change
  useEffect(() => {
    if (tab && matchDays?.length) fetchLeaderboard();
  }, [tab, week, day, matchDays]);

  console.log("MEMEMEME",day)

  const fetchLeaderboard = async () => {
    try {
      const tabInt = parseInt(tab);
      let params = { type: tabInt };

      if (tabInt === 1 && day) {
        params.group_label = day;
      } else if (tabInt === 2 && week) {
        params.week_number = parseInt(week.split(" ")[1], 10);
      }

      const res = await leaderboardDetails(params);

      if (res.data.status) {
        dispatch(LeaderBoardList(res.data.data));
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Simple handlers
  const handleTabChange = (event, newValue) => {
    dispatch(SetLeaderBoardTabs(newValue));
  };

  const handleWeekClick = (val) => {
    dispatch(SetWeekDay(val));
    setOpenWeek(false);
  };

  const handleDateClick = (dateObj) => {
    const dayString = dateObj.group_label;
    dispatch(SetDay(dayString));
    setOpenDaily(false);
  };

  return (
    <div className="mobileLeaderboard">
      <div className="mobileLeaderboard-tabs">
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab
                label="Daily"
                value="1"
                className="tabs-here"
                onClick={() =>{ 
                 dispatch(SetDay(settings?.current_group_label)) 
                  setOpenDaily(true)
                }
                }
              />
              <Tab label="All Time" value="3" className="tabs-here-all" />
              <Tab
                label="Weekly"
                value="2"
                className="tabs-here"
                onClick={() => weekDays?.length > 0 && setOpenWeek(true)}
              />
            </TabList>
          </Box>
          <GoldenBallPromo/>

          <TabPanel value="1">
            <Leaderboard
              leaderboard={leaderboardData}
              type={1}
              date={day}
              day={day}
              onDateClick={() => setOpenDaily(true)}
            />
          </TabPanel>

          <TabPanel value="3">
            <Leaderboard
              leaderboard={leaderboardData}
              allTimeWinners={finalWinners}
              type={3}
            />
          </TabPanel>

          <TabPanel value="2">
            <Leaderboard
              leaderboard={leaderboardData}
              type={2}
              weekNumber={week}
              onWeekClick={() => setOpenWeek(true)}
            />
          </TabPanel>
        </TabContext>
      </div>

      {/* Daily Dialog */}
      <Dialog
        open={openDaily}
        TransitionComponent={Transition}
        onClose={() => setOpenDaily(false)}
      >
        <div className="timeOverModal-wrapper" style={{ cursor: "pointer" }}>
          <div className="timeOverModal-header">
            <h2>Choose Match Day</h2>
          </div>
          <div className="daySelection-modal-bottom">
            <div className="daySelection-bottom-wrapper">
              {matchDays.map((item) => {
                const start = Moment(item.start_date, "YYYY-MM-DD");
                const end = Moment(item.end_date, "YYYY-MM-DD");
                const dateRange = start.isSame(end, "day")
                  ? start.format("DD MMM YYYY")
                  : `${start.format("DD MMM")} - ${end.format("DD MMM")}`;

                return (
                  <p
                    key={item.date}
                    onClick={() => handleDateClick(item)}
                    style={{ textAlign: "center" }}
                  >
                    {item.day}
                    <span style={{ fontSize: "0.65em", opacity: 0.65, marginLeft: 6 }}>
                      ({dateRange})
                    </span>
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </Dialog>

      {/* Weekly Dialog */}
      <Dialog
        open={openWeek}
        TransitionComponent={Transition}
        onClose={() => setOpenWeek(false)}
      >
        <div
          className="timeOverModal-wrapper"
          style={{ cursor: "pointer", textAlign: "center" }}
        >
          <div className="timeOverModal-header">
            <h2>Choose Week</h2>
          </div>
          <div className="daySelection-modal-bottom">
            <div className="daySelection-bottom-wrapper">
              {weekDays.map((val) => (
                <p key={val} onClick={() => handleWeekClick(val)}>
                  {val}
                </p>
              ))}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MobileLeaderboard;
